// @ts-nocheck
import { DashboardhMediumButton } from 'bd-web-components'
import Lottie from 'react-lottie'
import * as successAnimation from '../../assets/success-modal.json'
import * as errorAnimation from '../../assets/error-modal.json'
import {
  ButtonBox,
  GifBox,
  PageSubtitle,
  PageTitle,
  StyledModal,
} from './styles'
import {
  GRAY_SCALE_10,
  SECONDARY_BLUE_01,
} from 'bd-web-components/src/utils/dash-colors'
import Loader from '../Loader'
import { format } from 'date-fns'
import { UseBooleanReturn } from '../../hooks/use-boolean'
import { useCallback, useEffect } from 'react'
import useBdApp from '../../hooks/bdapp/useBdApp'

interface ConfirmationModalProps {
  isOpen: boolean
  customSuccess?: CustomMgsProp
  customError?: CustomMgsProp
  isSuccess: boolean | null
  rollBackUrl: string
  goAhead?: boolean
  goAheadUrl?: string
  goAheadText?: string
  onRequestClose?: () => void
  setIsOpen: (b: boolean) => void
  goNPS?: {
    show: boolean
    object: UseBooleanReturn
  }
}
interface CustomMgsProp {
  title: string
  subtitle: string
  // button: string
}
export interface ConfirmationProps {
  customSuccess: CustomMgsProp
  customError: CustomMgsProp
}

export const SucessOrFailModal = ({
  goAhead,
  goAheadText,
  goAheadUrl,
  goNPS,
  rollBackUrl,
  isOpen,
  isSuccess = true,
  onRequestClose,
  setIsOpen,
  customSuccess = {
    title: 'Solicitação realizada com sucesso',
    subtitle: 'Agora é só aguardar!',
    // button: 'Voltar',
  },
  customError = {
    title: 'Um erro aconteceu nesta solicitação',
    subtitle: 'Tente novamente!',
    // button: 'Voltar',
  },
}: ConfirmationModalProps) => {
  const handlerNavigate = (url: string, actionControl: boolean) => {
    if (actionControl) {
      setIsOpen(false)
      window.location.href = url
      return null
    } else {
      window.location.reload()
    }
  }

  const handlerNPS = useCallback(() => {
    setIsOpen(false)
    goNPS?.object.onTrue()
  }, [goNPS, setIsOpen])

  const { isNative } = useBdApp()

  const title = isSuccess ? customSuccess.title : customError.title
  const subtitle = isSuccess ? customSuccess.subtitle : customError.subtitle
  const animation = isSuccess ? successAnimation : errorAnimation

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  const hasGoAhead =
    goAhead !== undefined &&
    goAheadUrl !== undefined &&
    goAheadText !== undefined

  const hasGoNPS = goNPS?.show

  const time = format(new Date(), 'dd/MM/yyyy p')

  useEffect(() => {
    if (hasGoNPS && isSuccess) {
      setTimeout(() => {
        handlerNPS()
      }, 2000)
    }
  }, [hasGoNPS, isSuccess, handlerNPS])

  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      }}
    >
      {isSuccess === null && <Loader />}
      {isSuccess !== null && (
        <>
          <GifBox>
            <Lottie
              options={defaultOptions}
              isStopped={false}
              isPaused={false}
            />
          </GifBox>
          <PageTitle>{title}</PageTitle>
          <PageSubtitle>{subtitle}</PageSubtitle>
          <ButtonBox>
            {hasGoAhead && isSuccess && !isNative && (
              <DashboardhMediumButton
                onClick={() =>
                  handlerNavigate(goAheadUrl as string, isSuccess as boolean)
                }
                color="#FFF"
                background={SECONDARY_BLUE_01}
                height="48px"
                maxWidth="100%"
                variant="contained"
                width="268px"
              >
                {goAheadText}
              </DashboardhMediumButton>
            )}
            {!hasGoNPS &&
              isSuccess &&
              !isNative && (
                <DashboardhMediumButton
                  onClick={() =>
                    handlerNavigate(rollBackUrl, isSuccess as boolean)
                  }
                  color="#000"
                  background={GRAY_SCALE_10}
                  height="48px"
                  maxWidth="100%"
                  variant="outlined"
                  width="268px"
                >
                  {'Voltar'}
                </DashboardhMediumButton>
              )}
            {isSuccess === false && !isNative && (
              <DashboardhMediumButton
                onClick={() => setIsOpen(false)}
                color="#000"
                background={GRAY_SCALE_10}
                height="48px"
                maxWidth="100%"
                variant="outlined"
                width="268px"
              >
                {'Voltar'}
              </DashboardhMediumButton>
            )}
          </ButtonBox>
          <div
            style={{
              marginTop: '10px',
              height: 10,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <PageSubtitle>{time.toString()}</PageSubtitle>
          </div>
        </>
      )}
    </StyledModal>
  )
}
